/**
 * @module acng/picturePool
 */
import angular from 'angular';

import angularTranslate, {provideTranslations} from 'acng/core/service/angular-translate';

import './config/routes';
import featureName from './config/feature.js';
import './attribute/index.js';
import './element/index.js';

angular
  .module(featureName, [angularTranslate]) //
  .config(provideTranslations(featureName));
